import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumb, Row, Button, Tooltip, message } from 'antd';
import Table from 'components/Table';
import NewFilter from 'components/NewFilter';
import { Link } from 'react-router-dom';
import get from 'lodash/get';
import moment from 'moment';
import { FILTER_TYPE, paginationParam } from 'shared/constant';
import { permissionService } from 'shared/services';

import { elipsis } from 'shared/utils/StringUtil';
import tableUtil from 'shared/utils/TableUtil';
import urlUtil from 'shared/utils/UrlUtil';
import AddClientModal from './AddClient.modal';
import ClientDetailsModal from './ClientDetails.modal';
import ConfirmRevokeModal from './ConfirmRevoke.modal';

import text from './ClientList.page.translation';
import './ClientList.style.less';

import deliveryRoute from '../../route';

const { checkPermission } = permissionService;

class ClientList extends Component {
  constructor(props) {
    super(props);

    const { resetFilter, match } = this.props;
    if (!match.params.page) {
      resetFilter();
    }

    this.state = {
      addClientModalVisible: false,
      clientDetailsModalVisible: false,
      selectedClientId: '',
      confirmRevokeModalVisible: false,
    };
  }

  componentDidMount = () => {
    const { match, filterValue } = this.props;
    if (match.params.page) {
      this.updateClientTable(filterValue);
    } else {
      this.updateClientTable([]);
    }
  };

  componentDidUpdate(prevProps) {
    const { formControlShow, match, filterValue } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.updateClientTable(filterValue);
    }

    if (prevProps.filterValue !== filterValue && !formControlShow) {
      if (
        !(
          prevProps.filterValue.length > 0 &&
          prevProps.filterValue.length > filterValue.length &&
          prevProps.filterValue[prevProps.filterValue.length - 1].inputValue
            .length === 0
        )
      ) {
        if (
          prevProps.match.params.page !== match.params.page ||
          (prevProps.match.params.page === match.params.page &&
            match.params.page > 1)
        ) {
          this.handleChangePage(1);
        } else {
          this.updateClientTable(filterValue);
        }
      }
    }
  }

  handleChangePage = page => {
    urlUtil.changePageParams(
      deliveryRoute.CLIENT_LIST,
      page,
      this.props.history,
    );
  };

  openAddClientModal = () => {
    this.updateAddClientModalVisible(true);
  };

  renderAddNewClientButton = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Button
        type="primary"
        size="large"
        className="btn btn-add-client"
        onClick={this.openAddClientModal}
      >
        {formatMessage(text.btn.addNewClient)}
      </Button>
    );
  };

  renderBreadCrumb = () => {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <Row className="breadcrumb-wrapper">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">{formatMessage(text.home)}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{formatMessage(text.clientList)}</Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    );
  };

  renderTable = () => {
    const {
      intl: { formatMessage },
      clientList,
      clientFilter,
      loading,
    } = this.props;

    const pageSize = get(clientFilter, 'page_size');
    const pageCount = get(clientFilter, 'page_count');
    const pageNum = get(clientFilter, 'page_num');
    const totalItem = pageSize * pageCount;

    const tableColumns = this.renderColumns(pageNum, pageSize, formatMessage);

    return (
      <Table
        bordered
        columns={tableColumns}
        dataSource={clientList}
        pagination="true"
        rowKey={this.getRowKey}
        rowClass="striped-table"
        loadingValue={loading}
        totalItem={totalItem}
        currentPage={pageNum}
        changePage={this.handleChangePage}
      />
    );
  };

  renderAction = record => {
    const {
      intl: { formatMessage },
    } = this.props;

    const clientId = get(record, 'id', '');
    const canDeleteClient = checkPermission('Client:delete', true);

    return (
      <div className="action-container">
        <div className="action">
          {canDeleteClient && (
            <button
              type="button"
              className="btn-red"
              onClick={this.onClickRevokeLink(clientId)}
            >
              {formatMessage(text.btn.revoke)}
            </button>
          )}
        </div>
      </div>
    );
  };

  renderColumns = (pageNum, pageSize, formatMessage) => [
    {
      title: formatMessage(text.header.no),
      key: 'index',
      width: 80,
      render: this.renderNoColumn(pageNum, pageSize),
    },
    {
      title: formatMessage(text.header.clientName),
      key: 'name',
      render: this.renderClientName,
      width: 200,
    },
    {
      title: formatMessage(text.header.picEmail),
      key: 'email',
      dataIndex: 'email',
    },
    {
      title: formatMessage(text.header.apiKey),
      key: 'api_key',
      width: 120,
      dataIndex: 'api_key',
    },
    {
      title: formatMessage(text.header.secretKey),
      key: 'secret_key',
      width: 120,
      dataIndex: 'secret_key',
    },
    {
      title: formatMessage(text.header.createdOn),
      key: 'created_at',
      dataIndex: 'created_at',
      width: 230,
      render: this.renderCreatedOn,
    },
    {
      title: formatMessage(text.header.action),
      key: 'action',
      render: this.renderAction,
      width: 120,
    },
  ];

  getRowKey = record => record.id;

  renderClientNameText = getValue => (
    <Tooltip placement="topLeft" title={getValue}>
      <span>{elipsis(getValue, 30)}</span>
    </Tooltip>
  );

  renderClientName = record => {
    const getValue = get(record, 'name', '');
    const clientId = get(record, 'id', '');

    const clientNameText = this.renderClientNameText(getValue);
    const canViewClientKey = checkPermission('Client Key:read', true);

    if (canViewClientKey) {
      return (
        <button
          type="button"
          className="btn-blue left-text"
          onClick={this.onSelectClientName(clientId)}
        >
          {clientNameText}
        </button>
      );
    }

    return clientNameText;
  };

  renderNoColumn = (pageNum, pageSize) => (_text, _record, index) =>
    tableUtil.getColumnNo(index, pageSize, pageNum);

  renderCreatedOn = record => {
    if (record) {
      const reformatTimestamp = moment(record).format('DD-MMM-YYYY, HH:mm');
      return `${reformatTimestamp} WIB`;
    }
    return `-`;
  };

  buildGetParamUrl = filterValue => {
    let result = '';

    filterValue.forEach(element => {
      const value = element.inputValue[0];
      switch (element.key) {
        default:
          result += `&${element.key}=${value}`;
          break;
      }
    });

    return result;
  };

  buildPaginationUrl = clientFilter => {
    let result = '';
    result += `page_size=${encodeURIComponent(clientFilter.page_size)}`;
    result += `&page_count=${encodeURIComponent(clientFilter.page_count)}`;
    result += `&page_num=${encodeURIComponent(clientFilter.page_num)}`;

    return result;
  };

  updateClientTable = filterValue => {
    const { getListClient, clientFilter, match, history } = this.props;

    let paginationValue = { ...paginationParam };
    let paramUrl = '';
    const page = get(match, 'params.page', '');
    const pageInt = parseInt(page, 10) || '';

    if (filterValue.length > 0) {
      paramUrl = this.buildGetParamUrl(filterValue);
    }

    if (page) {
      if (pageInt && pageInt >= 1) {
        paginationValue = {
          ...clientFilter,
          page_num: pageInt,
        };
        const paginationUrl = this.buildPaginationUrl(paginationValue);
        getListClient(paginationUrl, paramUrl);
      } else {
        history.push(deliveryRoute.CLIENT_LIST);
      }
    } else {
      const paginationUrl = this.buildPaginationUrl(paginationValue);
      getListClient(paginationUrl, paramUrl);
    }
  };

  refreshTable = () => {
    const { getListClient, clientFilter, filterValue } = this.props;
    const paginationUrl = this.buildPaginationUrl(clientFilter);
    const paramUrl = this.buildGetParamUrl(filterValue);

    getListClient(paginationUrl, paramUrl);
  };

  updateAddClientModalVisible = show => {
    this.setState({
      addClientModalVisible: show,
    });
  };

  cancelAddClient = () => {
    this.updateAddClientModalVisible(false);
  };

  createNewClient = formValues => {
    const { createNewClient } = this.props;

    createNewClient(
      formValues,
      this._onCreateNewClientSuccess,
      this._onCreateNewClientError,
    );
  };

  _onCreateNewClientSuccess = () => {
    const { filterValue } = this.props;

    message.success('Create new client success');
    this.updateAddClientModalVisible(false);
    this.updateClientTable(filterValue);
  };

  _onCreateNewClientError = () => {
    message.error('Create new client failed');
  };

  renderAddClientModal = () => {
    const { createNewClientLoading } = this.props;

    return (
      <AddClientModal
        visible={this.state.addClientModalVisible}
        intl={this.props.intl}
        handleCancel={this.cancelAddClient}
        handleSuccess={this.createNewClient}
        createNewClientLoading={createNewClientLoading}
      />
    );
  };

  updateClientDetailsModalVisible = show => {
    this.setState({
      clientDetailsModalVisible: show,
    });
  };

  closeClientDetailsModal = () => {
    this.updateClientDetailsModalVisible(false);
  };

  onSelectClientName = clientId => event => {
    event.preventDefault();

    this.setState(
      {
        selectedClientId: clientId,
      },
      this.getClientDetails,
    );
  };

  getClientDetails = () => {
    const { getClientDetails } = this.props;

    getClientDetails(
      this.state.selectedClientId,
      this.onGetClientDetailsSuccess,
      this.onGetClientDetailsError,
    );
  };

  onGetClientDetailsSuccess = () => {
    this.updateClientDetailsModalVisible(true);
  };

  onGetClientDetailsError = error => {
    this.updateClientDetailsModalVisible(false);
    message.error(error);
  };

  refreshClient = () => {
    const { refreshClient } = this.props;

    refreshClient(
      this.state.selectedClientId,
      this.onRefreshClientSuccess,
      this.onRefreshClientError,
    );
  };

  onRefreshClientSuccess = () => {
    message.success('Refresh success');
  };

  onRefreshClientError = () => {
    message.error('Refresh error');
  };

  renderClientDetailsModal = () => {
    const {
      getClientDetailsLoading,
      clientDetails,
      refreshClientLoading,
    } = this.props;

    return (
      <ClientDetailsModal
        visible={this.state.clientDetailsModalVisible}
        intl={this.props.intl}
        handleClose={this.closeClientDetailsModal}
        handleRefresh={this.refreshClient}
        clientDetails={clientDetails}
        getClientDetailsLoading={getClientDetailsLoading}
        refreshClientLoading={refreshClientLoading}
      />
    );
  };

  updateConfirmRevokeModalVisible = show => {
    this.setState({
      confirmRevokeModalVisible: show,
    });
  };

  onClickRevokeLink = clientId => event => {
    event.preventDefault();

    this.setState({
      selectedClientId: clientId,
      confirmRevokeModalVisible: true,
    });
  };

  cancelRevoke = () => {
    this.updateConfirmRevokeModalVisible(false);
  };

  revokeClient = () => {
    const { revokeClient } = this.props;

    revokeClient(
      this.state.selectedClientId,
      this.onRevokeClientSuccess,
      this.onRevokeClientError,
    );
  };

  onRevokeClientSuccess = () => {
    const { filterValue, clientList, match } = this.props;

    this.updateConfirmRevokeModalVisible(false);
    message.success('Revoke client success');

    if (clientList.length === 1) {
      const page = get(match, 'params.page', '');
      const pageInt = parseInt(page, 10) || '';

      if (pageInt > 1) {
        const newPage = page - 1;
        this.handleChangePage(newPage);
      }
    } else {
      this.updateClientTable(filterValue);
    }
  };

  onRevokeClientError = () => {
    this.updateConfirmRevokeModalVisible(false);
    message.error('Revoke client failed');
  };

  renderConfirmRevokeModal = () => {
    const { intl, revokeClientLoading } = this.props;

    return (
      <ConfirmRevokeModal
        intl={intl}
        visible={this.state.confirmRevokeModalVisible}
        handleCancel={this.cancelRevoke}
        handleRevoke={this.revokeClient}
        loadingRevoke={revokeClientLoading}
      />
    );
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;

    const options = [
      {
        label: formatMessage(text.filter.clientName),
        value: 'name',
        type: FILTER_TYPE.TEXT,
      },
      {
        label: formatMessage(text.filter.picEmail),
        value: 'email',
        type: FILTER_TYPE.TEXT,
      },
    ];

    const canAddClient = checkPermission('Client:create', true);

    return (
      <div className="main-content client-management">
        {this.renderBreadCrumb()}
        <div className="white-box-wrapper">
          <span className="title mbottom30">
            {formatMessage(text.clientList)}
          </span>

          <div className="add-btn-wrapper">
            {canAddClient && this.renderAddNewClientButton()}
          </div>

          <NewFilter options={options} />

          <div className="table-wrapper">{this.renderTable()}</div>

          {this.renderAddClientModal()}
          {this.renderClientDetailsModal()}
          {this.renderConfirmRevokeModal()}
        </div>
      </div>
    );
  }
}

ClientList.propTypes = {
  intl: PropTypes.object,
  match: PropTypes.object,
  loading: PropTypes.bool,
  history: PropTypes.object,
  clientList: PropTypes.array,
  clientFilter: PropTypes.object,
  resetFilter: PropTypes.func,
  filterValue: PropTypes.array,
  formControlShow: PropTypes.bool,
  getListClient: PropTypes.func,
  clientDetails: PropTypes.object,
  getClientDetails: PropTypes.func,
  getClientDetailsLoading: PropTypes.bool,
  createNewClient: PropTypes.func,
  createNewClientLoading: PropTypes.bool,
  revokeClient: PropTypes.func,
  revokeClientLoading: PropTypes.bool,
  refreshClient: PropTypes.func,
  refreshClientLoading: PropTypes.bool,
};

export default ClientList;
